import * as _ from "lodash";
import "select2";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions
} from "../../dashboard/modify_widgets/_BaseModifyWidgetView";


export class ModifyTitleWidgetView extends BaseModifyDashboardWidgetView {

    private template = _.template(require('templates/modals/reports/modify_widgets/titlewidget/titlewidget.html'));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any> _.extend({
            tagName: "div",
            className: 'widget-type-channels',
            events: {}
        }, options));

        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: []
            });
        }
    }

    render() {
        this.$el.html(this.template({
            widget: this.options.widget,
            exampleImg: require('../../../../../img/widgettypes/title/titlewidgetexample.png')
        }));
        return this;
    }

    preSave() {
        var title = this.$('input.add-title').val();
        this.options.widget.setParamValue('TITLE_WIDGET_TITLE', title);

        return true;
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/reports/modify_widgets/ModifyTitleWidgetView.ts